import { supabase } from '@/core/database/supabase';
import type { EstimateBoqLink } from '../types/estimate.types';

function normalizeLink(row: any): EstimateBoqLink {
  return {
    id: row.id,
    company_id: row.company_id,
    project_id: row.project_id,
    estimate_id: row.estimate_id,
    estimate_item_id: row.estimate_item_id,
    estimate_version_id: row.estimate_version_id,
    boq_id: row.boq_id,
    boq_item_id: row.boq_item_id,
    created_at: row.created_at,
    boq: row.boq || null,
    boq_item: row.boq_item || null,
  };
}

export const estimateBoqLinksService = {
  async getByEstimateId(estimateId: string): Promise<EstimateBoqLink[]> {
    const { data, error } = await supabase
      .from('estimate_to_boq_links' as any)
      .select(`
        *,
        boq:construction_boqs(id, boq_code, boq_name),
        boq_item:construction_boq_items(id, item_code, item_name)
      `)
      .eq('estimate_id', estimateId)
      .order('created_at', { ascending: false });

    if (error) {
      const missingTable = error.code === '42P01' || error.message?.includes('estimate_to_boq_links');
      if (missingTable) return [];
      throw error;
    }

    return ((data || []) as any[]).map(normalizeLink);
  },
};
